export const FILTER_RANGE_OPTIONS = [[1, 5], [5, 15], [15, 50], [50, 100], [100, Number.MAX_VALUE]];
